import React from "react"
import styled from "styled-components"
import Colors from "../res/styles/Colors"
import { HeroText } from "../res/styles/TextStyles"
import { Col } from "../res/styles/Common"

const Background = styled.div`
    background-color: ${Colors.heroback};
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    z-index: 0;
    white-space: pre-line;
`

const BgImage = styled.img`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    object-fit: cover;
`

function Hero(props) {
    return (
        <>
            <BgImage src={props.bg} />
            <Background>
                <Col>
                    <HeroText>{props.title}</HeroText>
                    <HeroText sm>{props.subtitle}</HeroText>
                </Col>
            </Background>
        </>
    )
}

export default Hero
